var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkippedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "69912920-F056-464D-AA44-B70F35C594F2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EID---My-Tasks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Tasks---Approver---Details---Business-Request---Process-Steps---2",
    transform: "translate(-1253.000000, -681.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drawer",
    transform: "translate(462.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "organism/pdp/content/business/normal",
    transform: "translate(0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/organism/process-steps/br/step-2",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(48.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(384.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/molecules/progress-status/skip",
    transform: "translate(348.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-ns",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0 C17.5128358,0 17.9355072,0.38604019 17.9932723,0.883378875 L18,1 L18,17 C18,17.5522847 17.5522847,18 17,18 C16.4871642,18 16.0644928,17.6139598 16.0067277,17.1166211 L16,17 L16,1 C16,0.44771525 16.4477153,0 17,0 Z",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31500853,2.9452998 L-1.68499147,14.9452998 C-2.12802796,15.6098545 -1.65163656,16.5 -0.852941176,16.5 L15.1470588,16.5 C15.9457542,16.5 16.4221456,15.6098545 15.9791091,14.9452998 L7.97910912,2.9452998 C7.58328707,2.35156673 6.71083058,2.35156673 6.31500853,2.9452998 Z M7.14705882,5.303 L13.2780588,14.5 L1.01505882,14.5 L7.14705882,5.303 Z",
    id: "Triangle",
    transform: "translate(7.147059, 9.500000) rotate(-270.000000) translate(-7.147059, -9.500000) "
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedIcon);
export default __webpack_public_path__ + "static/media/skipped-icon.a9e0dc60.svg";
export { ForwardRef as ReactComponent };